/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TenantDomainModel } from './TenantDomainModel';
export type TenantInformation = {
  readonly firm?: number;
  readonly id?: number;
  readonly sp_entity_id?: string;
  readonly acs_url?: string;
  enforced_sso?: boolean;
  jit_provisioning_enabled?: boolean;
  default_firm_role?: TenantInformation.default_firm_role;
  domains: Array<TenantDomainModel>;
};
export namespace TenantInformation {
  export enum default_firm_role {
    '_0' = 0,
    '_2' = 2,
    '_4' = 4,
    '_5' = 5,
    '_6' = 6,
    '_7' = 7,
    '_8' = 8,
  }
}

